import { writable } from "svelte/store";
import { fetchZipCodes } from "./fetchZipCodes";
const initialState = [];
export const getZipStore = (sheetConfig) => {
    const store = writable(initialState);
    const load = async () => {
        try {
            const res = await fetchZipCodes(sheetConfig);
            console.log("response: ", res);
            store.set(res);
        }
        catch (e) {
            console.log("Cannot load zips", e);
        }
    };
    return { store, load };
};
